import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "question-reason" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_4 = {
  class: "line-only",
  style: {"text-overflow":"ellipsis","width":"100%","overflow":"hidden","text-align":"left"}
}
const _hoisted_5 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { style: {"max-width":"200px","font-size":"14px"} }

import { WarningFilled } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { getAbnormalDetailApi } from '@/apis/order'
import ADialogDrawer from './ADialog_drawer.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: () => {
      return {}
    }
  },
  type: {
    type: [String, Number],
    default: ''
  },
  isTip: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props
const questionReasonList: any = {
  // 取消发货记录
  1: {
    0: {
      text: t('お客様申請(発送キャンセル済)')
    },
    1: {
      text: t('お客様申請(発送キャンセル済・在庫保有)')
    },
    2: {
      text: t('客户重新分配库存取消')
    },
    22: {
      text: t('カラー・サイズ不明'),
      btn: t('異常注文処理履歴')
    },
    23: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    24: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    25: {
      text: t('予約販売'),
      btn: t('異常注文処理履歴')
    },
    26: {
      text: t('最小注文ロット数あり'),
      btn: t('異常注文処理履歴')
    },
    27: {
      text: t('不良品'),
      btn: t('異常注文処理履歴')
    },
    28: {
      text: t('不良品'),
      btn: t('異常注文処理履歴')
    },
    29: {
      text: t('不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)'),
      btn: t('異常注文処理履歴')
    },
    30: {
      text: t('不良品(不良品対応設定で「返品返金」ご指定)')
    },
    31: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    32: {
      text: t('在庫切れ(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)')
    },
    33: {
      text: t('全サイト在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    34: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    35: {
      text: t('不良品'),
      btn: t('異常注文処理履歴')
    },
    36: {
      text: t('不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)'),
      btn: t('異常注文処理履歴')
    },
    37: {
      text: t('不良品(不良品対応設定で「返品返金」ご指定)')
    },
    38: {
      text: t('全サイト在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    39: {
      text: t('在庫切れ再発注完了')
    },
    40: {
      text: t('不良品返品完了')
    },
    46: {
      text: t('不良品返品完了')
    }
  },
  // 取消采购记录
  0: {
    0: {
      text: t('お客様申請(仕入れキャンセル済)')
    },
    2: {
      text: t('客户重新分配库存取消')
    },
    22: {
      text: t('カラー・サイズ不明'),
      btn: t('異常注文処理履歴')
    },
    23: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    24: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    25: {
      text: t('予約販売'),
      btn: t('異常注文処理履歴')
    },
    26: {
      text: t('最小注文ロット数あり'),
      btn: t('異常注文処理履歴')
    },
    27: {
      text: t('不良品返品完了'),
      btn: t('異常注文処理履歴')
    },
    28: {
      text: t('不良品返品完了')
    },
    29: {
      text: t('不良品返品完了')
    },
    30: {
      text: t('不良品返品完了')
    },
    31: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    32: {
      text: t('在庫切れ(自動再仕入れ回数上限に達した)')
    },
    33: {
      text: t('全サイト在庫切れ')
    },
    34: {
      text: t('在庫切れ'),
      btn: t('異常注文処理履歴')
    },
    35: {
      text: t('不良品'),
      btn: t('異常注文処理履歴')
    },
    36: {
      text: t('不良品(自動再仕入れ回数上限に達した)')
    },
    37: {
      text: t('不良品(不良品対応設定で「返品返金」ご指定)')
    },
    38: {
      text: t('全サイト在庫切れ')
    },
    39: {
      text: t('在庫切れ再発注完了')
    },
    40: {
      text: t('不良品返品完了')
    },
    41: {
      text: t('不良品返品完了')
    },
    42: {
      text: t('不良品返品完了')
    },
    45: {
      text: t('不良品返品完了')
    },
    46: {
      text: t('不良品返品完了')
    }
  }
}

const questionObj = computed(() => {
  if (props.type === 2) {
    return questionReasonList?.[1]?.[props.item.productQuestionType] ?? questionReasonList?.[2]?.[props.item.productQuestionType]
  }
  return questionReasonList?.[props.type]?.[props.item.productQuestionType]
})
const ProblemVisible = ref(false)
const rowItem: any = ref({})
const openDialog = (row: any) => {
  getAbnormalDetailApi({
    purchaseAbnormalOrderId: row.bizId
  }).then((res: any) => {
    rowItem.value = res.data
    try {
      rowItem.value.abnormalDetailMessageSeverity = JSON.parse(rowItem.value.abnormalDetailMessageSeverity)
    } catch { }
    ProblemVisible.value = true
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.isTip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(questionObj)?.text), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(questionObj)?.text), 1)
              ]),
              _: 1
            }),
            (!__props.isTip && __props.item.cancelType === 2 && __props.item.cancelDetailType === 22)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('超过60天用户未处理，系统已自动处理')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      size: 14,
                      class: "cursor-pt",
                      style: {"vertical-align":"middle"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(WarningFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(questionObj)?.text) + " ", 1),
            (!__props.isTip && __props.item.cancelType === 2 && __props.item.cancelDetailType === 22)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('超过60天用户未处理，系统已自动处理')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      size: 14,
                      class: "cursor-pt",
                      style: {"vertical-align":"middle"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(WarningFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])),
      (_unref(questionObj)?.btn && !__props.isTip && __props.item.customerOperateStatus !== 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            style: {"font-size":"12px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openDialog(props.item)))
          }, _toDisplayString(_unref(questionObj)?.btn), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ADialogDrawer, {
      title: _unref(t)('处理详情'),
      visible: ProblemVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((ProblemVisible).value = $event)),
      rowItem: rowItem.value,
      onlyRead: true
    }, null, 8, ["title", "visible", "rowItem"])
  ], 64))
}
}

})